<template>
  <div style="max-height: 60vh; min-height: 15vh ;overflow: scroll">
    <div
      v-if="!comments || !comments.length"
      style="text-align: center; margin-top: 5vh"
    >
      <span>
        <h5>{{ $t('documentRequests.warningText.noComment') }}</h5>
      </span>
    </div>
    <div
      v-else
    >
      <b-card
        v-for="(comment, index) in comments"
        :key="`comment-${index}`"
      >
        <div class="d-flex align-items-baseline">
          <h5 style="text-transform: capitalize;">
            {{ comment.submitter }}
          </h5>
          <small
            class="text-muted"
            style="margin-left: 15px"
          >{{ comment.date.toDate().toLocaleString('fi', {
            month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
          ) }}</small>
        </div>

        <b-row>
          <pre style="background: none; margin-left: 15px; max-width: 100%; white-space: pre-wrap; font-size: 14px; color: rgba(0,0,0,0.8)">{{ comment.text }}</pre>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>
